module.exports = __webpack_public_path__ + "static/img/2_1_2.d86c7901.jpg";